import type { ParamMatcher } from '@sveltejs/kit';
import { isValidTransactionAsset } from '$lib/utils/isValidTransactionAsset';

export const match: ParamMatcher = (param): boolean => isValidTransactionAsset(param);
